import items from '@/data/dashboard/management-items'

const BACKGROUND_IMAGES = [
  require('@/assets/images/management/1.png'),
  require('@/assets/images/management/2.png'),
  require('@/assets/images/management/3.png'),
  require('@/assets/images/management/4.png'),
  require('@/assets/images/management/5.png'),
  require('@/assets/images/management/6.png')
]

export default {
  name: 'ManagementPage',
  data () {
    return {
      items
    }
  },
  methods: {
    style (i) {
      return {
        backgroundImage: 'url(' + BACKGROUND_IMAGES[i] + ')'
      }
    },
    icon (i) {
      return require('@/assets/images/icons/management/medium/' + i.icon + '.png')
    }
  }
}